import Skeleton from '@mui/material/Skeleton';
import { alpha, Box, Divider, List, ListItem, Paper } from '@mui/material';
import { BusinessCustomListItemStyled, DataTextBox, LeftBox, OrderList, OrderListItem, UnorderList, UnorderListItem } from './style';
import React from 'react';
import { CustomAccordion } from '../../components/Accordion';

export const skeleton = (
    <>
        <Box display={'flex'} height={'100%'} padding={{ md: '24px' }} overflow={'auto'}>
            {/* Left Side Navigate UI */}
            <LeftBox>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Skeleton variant="text" sx={{ height: '2rem', width: '20%', minWidth: '10rem' }} />
                    <Skeleton
                        variant="rounded"
                        sx={{
                            width: '10%',
                            minWidth: '10rem',
                            height: '2.5rem',
                        }}
                    />
                </Box>

                <DataTextBox>
                    {Array.from(Array(4).keys()).map((_, index) => (
                        <React.Fragment key={index}>
                            <Box className="item" key={index} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                <Skeleton
                                    variant="rounded"
                                    sx={{
                                        width: '1.5rem',
                                        height: '1.5rem',
                                        marginRight: '0.5rem',
                                    }}
                                />
                                <Skeleton variant="text" sx={{ height: '1.5rem', width: '5rem' }} />
                            </Box>
                            <Divider
                                orientation="vertical"
                                variant="middle"
                                flexItem
                                sx={(theme) => ({
                                    margin: `${theme.typography.generic.none} ${theme.typography.generic.xxxLarge}`,
                                    color: theme.palette.grey[300],
                                })}
                            />
                        </React.Fragment>
                    ))}
                </DataTextBox>

                <Box
                    display={'flex'}
                    gap={'1rem'}
                    marginBottom={(theme) => theme.typography.generic.xxxxxLarge}
                    sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        width: {
                            xs: '13.18rem',
                            sm: '100%',
                        },
                    }}
                >
                    {Array.from(Array(2).keys()).map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rounded"
                            sx={{
                                width: '10%',
                                minWidth: '10rem',
                                height: '2.5rem',
                            }}
                        />
                    ))}
                </Box>

                {Array.from(Array(5).keys()).map((cItem, index) => (
                    <CustomAccordion
                        index={index}
                        summary={
                            <>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Box sx={{ ml: 2 }}>
                                    <Skeleton variant="text" sx={{ height: '1rem', width: '8rem' }} />
                                    <Skeleton variant="text" sx={{ height: '1rem', width: '5rem' }} />
                                </Box>
                            </>
                        }
                        details={
                            <>
                                <Divider
                                    sx={(theme) => ({
                                        margin: `${theme.typography.generic.large}  ${theme.typography.generic.none} `,
                                    })}
                                />

                                <Box
                                    component={'ul'}
                                    sx={{
                                        '& li': {
                                            marginBottom: '0.5rem',
                                        },
                                    }}
                                >
                                    {Array.from(Array(5).keys()).map((_, index) => {
                                        return (
                                            <BusinessCustomListItemStyled key={index} role="button" tabIndex={0}>
                                                <Box
                                                    sx={{
                                                        width: { sm: '50%', xs: '100%' },
                                                        minWidth: { sm: '50%', xs: '100%' },

                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Skeleton variant="circular" width={20} height={20} />

                                                    <Skeleton variant="text" sx={{ height: '1rem', width: '5rem', marginLeft: '0.5rem' }} />
                                                </Box>

                                                <Box
                                                    sx={{
                                                        width: { sm: '50%', xs: '100%' },
                                                        minWidth: { sm: '50%', xs: '100%' },
                                                        display: 'flex',
                                                        paddingLeft: {
                                                            xs: '2rem',
                                                            sm: 'unset',
                                                        },

                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <Skeleton variant="text" sx={{ height: '2rem', width: '20%' }} />

                                                    <Skeleton variant="text" sx={{ height: '2rem', width: '20%' }} />
                                                </Box>
                                            </BusinessCustomListItemStyled>
                                        );
                                    })}
                                </Box>
                            </>
                        }
                        sx={(theme) => ({
                            '&, &.Mui-expanded': {
                                margin: theme.typography.generic.none,
                                marginTop: theme.typography.generic.xLarge,
                                padding: theme.typography.generic.small,
                            },
                            background: theme.palette.background.paper,

                            boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.04)',
                        })}
                        expandIcon={<Skeleton variant="circular" width={10} height={10} />}
                    />
                ))}
            </LeftBox>

            {/* Right Side UI */}
            <Paper
                square={false}
                sx={(theme) => ({
                    width: '40%',
                    height: '100%',
                    overflow: 'auto',
                    marginLeft: '1rem',

                    [theme.breakpoints.down('md')]: {
                        display: 'none',
                        width: '100%',
                        marginLeft: '0',
                    },
                })}
            >
                <Box
                    className=""
                    display={'flex'}
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    width={{
                        xs: '100%',
                        sm: 'unset',
                    }}
                    padding={'1.25rem'}
                >
                    <Skeleton variant="circular" width={40} height={40} />
                    <Skeleton variant="text" sx={{ width: '9rem', marginLeft: '0.5rem', height: '1.5rem' }} />
                </Box>
                <Divider
                    sx={(theme) => ({
                        marginBottom: theme.typography.generic.xLarge,
                    })}
                />

                <Box margin={(theme) => `${theme.typography.generic.xxxxxLarge} ${theme.typography.generic.xxLarge}`}>
                    <Skeleton variant="text" sx={{ height: '1.4rem', width: '20%', minWidth: '8rem' }} />

                    <Box component={List} display={'flex'} flexDirection={'column'} gap={'0.5rem'}>
                        {Array.from(Array(4).keys()).map((_, index) => (
                            <ListItem
                                key={index}
                                sx={(theme) => ({
                                    border: `1px solid ${alpha(theme.palette.common.black, 0.1)}`,
                                    borderRadius: theme.typography.borderRadius.xxSmall,
                                    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.xSmall}`,

                                    display: 'flex',
                                    justifyContent: 'space-between',
                                })}
                            >
                                <Box
                                    sx={{
                                        width: '50%',
                                        minWidth: '50%',

                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Skeleton variant="rounded" width={20} height={20} />
                                    <Skeleton variant="text" sx={{ width: '4rem', height: '1rem', marginLeft: '0.5rem' }} />
                                </Box>
                                <Skeleton
                                    variant="rounded"
                                    sx={{
                                        width: '10%',
                                        minWidth: '5rem',
                                        height: '1rem',
                                    }}
                                />
                            </ListItem>
                        ))}
                    </Box>
                </Box>

                <Box
                    sx={(theme) => ({
                        padding: `${theme.typography.generic.none} ${theme.typography.generic.xxxLarge}`,
                    })}
                >
                    <Skeleton variant="text" sx={(theme) => ({ width: '20%' })} />
                    <Skeleton variant="text" sx={(theme) => ({ width: '100%', height: '3rem', marginBottom: theme.typography.generic.xSmall, fontWeight: theme.typography.fontWeightSemiBold })} />

                    <Skeleton
                        variant="text"
                        sx={(theme) => ({
                            width: '30%',
                            marginBottom: theme.typography.generic.xSmall,
                            margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none} ${theme.typography.generic.xSmall} ${theme.typography.generic.none}`,
                        })}
                    />

                    <OrderList>
                        {Array.from(Array(4).keys()).map((cList, index) => (
                            <OrderListItem key={index} sx={{ listStyle: 'none' }}>
                                <Skeleton variant="text" sx={{ display: 'inline-block', width: '40%', height: '1rem' }} />
                                <UnorderList sx={{ listStyle: 'none' }}>
                                    {Array.from(Array(2).keys()).map((_, idx) => (
                                        <UnorderListItem key={idx}>
                                            <Skeleton variant="text" sx={{ display: 'inline-block', width: '80%', height: '1rem' }} />
                                        </UnorderListItem>
                                    ))}
                                </UnorderList>
                            </OrderListItem>
                        ))}
                    </OrderList>
                </Box>
            </Paper>
        </Box>
    </>
);
